// extracted by mini-css-extract-plugin
export default {"container":"Parceiros_container__p4DXw","guarda":"Parceiros_guarda__3gLaS"};